import { useCallback } from 'react';
import { useGate, useTierForGate } from '@hotjar/allowances';
import { useCurrentSite } from '@hotjar/site';
import { noop } from '@hotjar/webapp/lib/function';
import { upsell } from '@hotjar/webapp/domains/revenue/upsell';
import { ColorPalette } from './ColorPalette';
import type { ColorPaletteProps } from './ColorPalette';

const GATE = 'feedback.survey_appearance_colors';

export function ColorPaletteGate(props: ColorPaletteProps): JSX.Element {
  const { data: currentSite } = useCurrentSite();
  const context = {
    type: 'site',
    id: `${currentSite?.id}`,
  } as const;
  const canUseAdvancedColors = useGate(GATE, context);
  const advancedColorsPlan = useTierForGate(GATE, context);
  const showUpsellModal = useCallback(() => {
    if (currentSite !== undefined)
      upsell({ site: currentSite, referrer: 'survey.appearance.colors' }).then(noop, noop);
  }, [currentSite]);

  return (
    <ColorPalette
      advancedColorsPlan={advancedColorsPlan ?? undefined}
      canUseAdvancedColors={canUseAdvancedColors ?? false}
      onUnavailableColorSelected={showUpsellModal}
      allowCustom
      {...props}
    />
  );
}
